/* Site-Specific JavaScript */
document.addEventListener('DOMContentLoaded', function () {
    var skipLinks = document.querySelectorAll('#skipLinks a[href^="#"]');
    skipLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(link.getAttribute('href'));
            if (!target) {
                return;
            }
            e.preventDefault();
            if (!target.hasAttribute('tabindex')) {
                target.setAttribute('tabindex', '-1');
            }
            target.focus({ preventScroll: false });
            target.scrollIntoView();
        });
    });
});
